var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16675 2.43415C1.16675 2.09805 1.29844 1.77571 1.53286 1.53805C1.76729 1.30039 2.08523 1.16687 2.41675 1.16687H14.9167C15.2483 1.16687 15.5662 1.30039 15.8006 1.53805C16.0351 1.77571 16.1667 2.09805 16.1667 2.43415V4.19652C16.1667 4.64462 15.991 5.07434 15.6784 5.39114L11.1667 9.96519V16.2374C11.1668 16.3958 11.1268 16.5516 11.0508 16.69C10.9747 16.8284 10.865 16.9448 10.732 17.0281C10.5991 17.1114 10.4474 17.1588 10.2913 17.1659C10.1352 17.173 9.97985 17.1396 9.84008 17.0687L6.74258 15.499C6.56956 15.4113 6.42404 15.2765 6.32233 15.1096C6.22063 14.9428 6.16675 14.7506 6.16675 14.5544V9.96519L1.65508 5.39114C1.3425 5.07434 1.16684 4.64462 1.16675 4.19652V2.43415ZM2.83341 2.85658V4.19652L7.46675 8.89391C7.58295 9.01158 7.67515 9.15131 7.73806 9.30512C7.80098 9.45893 7.83338 9.62379 7.83341 9.7903V14.1624L9.50008 15.0073V9.7903C9.50008 9.45405 9.63175 9.13132 9.86675 8.89476L14.5001 4.19567V2.85658H2.83341Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFilter);
export default __webpack_public_path__ + "static/media/greyFilter.6f86e1879f12bad6a09e4a338578a4cc.svg";
export { ForwardRef as ReactComponent };